module.exports = "Here is the process we'll follow.\n<div class=\"progressStepsContainer\">\n<as-progress-steps as-progress-steps=\"$ctrl.asProgressSteps\" > </as-progress-steps>\n</div>\n<p class=\"margin-b-20\">Copy the entire license below (including dashes). Go to your Appspace Console and paste the license there to apply this license to your on-prem server.\n</p>\n<as-copy text=\"$ctrl.payload\" hidecopybutton=\"$ctrl.hidecopybutton\"></as-copy>";


//////////////////
// WEBPACK FOOTER
// ./modules/license/features/license-renew-license-result/licenseRenewLicenseResult.component.html
// module id = 615
// module chunks = 0